export default __webpack_public_path__ + "static/media/02c23f3c5e77d0e303e84bd53ce0187c.svg";